import React, { Component, Fragment } from 'react';
// import RadioSelector from './selectors/Radio.jsx';
import OptionSelector from "./option";
import PersistenceManager from "../../../functions/persistence";
import PriceCalculator from "../../../functions/priceCalculations";
import Decorator from "../../../functions/decorator";

export default class DropdownModifierContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: this.findDefaultSelected(),
            isHidden: this.findDefaultSelected() !== 0,
            current_opt_value: -69,
            DefaultOptionDisabled: false
        };
        this.generateJSXFromData = this.generateJSXFromData.bind(this);
        this.removeSelections = this.removeSelections.bind(this);
        this.select = this.select.bind(this);
        this.findDefaultSelected = this.findDefaultSelected.bind(this);
        this.setCurrentKey = this.setCurrentKey.bind(this);
        this.optionValueChanged = this.optionValueChanged.bind(this);
        this.setDefaultOptionDisabled = this.setDefaultOptionDisabled.bind(this);
        this.handleDisabledOption = this.handleDisabledOption.bind(this);
    }

    optionValueChanged() {

    }

    setCurrentKey(event) {
        this.select(event.target.value);
    }

    findDefaultSelected() {
        let selectedMods = this.props.modifiers.filter( (val, ind, arr) => {
            const choice = this.props.choices[val];
            if(choice.quantity > 0) {
                return true;
            }
            return false;
        });
        if(selectedMods.length < 1) {
            //No selected mods set to 0
            return 0;
        }else {
            return selectedMods[0];
        }
    }

    generateJSXFromData() {
        let result = this.props.modifiers.map( (val, ind, arr) => {
            //Get the modifier's price in relation to the main item.
            const mod = this.props.allModifiers[val];
            const mainItem = this.props.itemGroup.items[this.props.selectedMainItem];
            const price = PriceCalculator.calculateModifierPriceForGivenItem(mainItem, mod);
            const formattedPrice = Decorator.formatCurrency(price);

            const displayName = price > 0 ? `${mod.name} - ${formattedPrice}` : mod.name;

            const choice = this.props.choices[val];
            return <OptionSelector
                setOptVal={this.optionValueChanged}
                select={this.select}
                selected={this.state.selected}
                key={ind}
                modifierKey={val}
                name={displayName}
                setExtra={this.props.setExtra}
                setLight={this.props.setLight}
                setNormal={this.props.setNormal}
                choice={choice}
                showChangeSelectionBtn={this.props.showChangeSelectionBtn}
            />;
            // let mainItemJ = $("option:selected", '#main_item_selected').attr("data-val");
            // if (typeof mainItemJ === "undefined") {
            //     let mainItemJ = JSON.parse(PersistenceManager.retrieveChosenMainItem());
            //
            //     let isAvailable = mod.priceLevels[mainItemJ.level] !== '-69.69';
            //
            //     if (isAvailable) {
            //         return <OptionSelector
            //             setOptVal={this.optionValueChanged}
            //             select={this.select}
            //             selected={this.state.selected}
            //             key={ind}
            //             modifierKey={val}
            //             name={mod.name}
            //             setExtra={this.props.setExtra}
            //             setLight={this.props.setLight}
            //             setNormal={this.props.setNormal}
            //             choice={choice}
            //             showChangeSelectionBtn={this.props.showChangeSelectionBtn}
            //         />;
            //     }
            // }
            // else {
            //     let mainItemJ = JSON.parse($("option:selected", '#main_item_selected').attr("data-val"));
            //
            //     let isAvailable = mod.priceLevels[mainItemJ.level] !== '-69.69';
            //
            //     if (isAvailable) {
            //         return <OptionSelector
            //             setOptVal={this.optionValueChanged}
            //             select={this.select}
            //             selected={this.state.selected}
            //             key={ind}
            //             modifierKey={val}
            //             name={mod.name}
            //             setExtra={this.props.setExtra}
            //             setLight={this.props.setLight}
            //             setNormal={this.props.setNormal}
            //             choice={choice}
            //             showChangeSelectionBtn={this.props.showChangeSelectionBtn}
            //         />;
            //     }
            // }
        });

        return result;
    }

    removeSelections() {
        this.props.modifiers.map( (val, ind, arr) => {
            this.props.removeModifier(val);
        })
    }

    setDefaultOptionDisabled() {
        this.setState({
            DefaultOptionDisabled: true
        })
    }

    select(key) {
        this.removeSelections();
        this.setDefaultOptionDisabled();
        this.setState({selected: key}, ()=> {
            this.props.setWhole(key)
            this.props.selectRadio(this.props.radioIndex, key);
        });
    }

    handleDisabledOption() {

    }

    render() {
            return (
                <div key={Math.random()}>
                    <h4 className="text-branded">{this.props.name}</h4>
                    <select className="form-control" onChange={this.setCurrentKey} id={Math.random()} value={this.state.selected}>
                        {!this.state.selected && <option>Please select.</option>}
                        {this.generateJSXFromData()}
                    </select>
                    <hr className="p-1 m-2" />
                </div>
            );
        }
}
